import { Link } from "react-router-dom";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen flex flex-col items-center justify-center bg-[var(--bg-default)] px-6 relative overflow-hidden">
      {/* Ambient glow */}
      <div className="absolute top-1/3 left-1/2 -translate-x-1/2 w-[40vw] h-[40vw] bg-[var(--gold)] opacity-[0.015] blur-[100px] rounded-full pointer-events-none" />

      <div className="hero-stagger text-center relative z-10">
        <p
          className="font-serif uppercase select-none pointer-events-none"
          style={{
            fontSize: 'clamp(80px, 15vw, 200px)',
            letterSpacing: '0.1em',
            color: '#151515',
            fontWeight: 300,
            lineHeight: 0.9,
            marginBottom: 'clamp(24px, 3vw, 48px)',
          }}
        >
          404
        </p>

        <div style={{ display: 'flex', justifyContent: 'center', marginBottom: '32px' }}>
          <div style={{ width: '40px', height: '1px', backgroundColor: 'var(--gold)', opacity: 0.4 }} />
        </div>

        <p className="font-sans text-[13px] uppercase tracking-[0.25em] text-[var(--text-tertiary)] mb-10">
          Page Not Found
        </p>

        <Link
          to="/"
          data-testid="not-found-home-link"
          className="inline-block font-sans text-[11px] uppercase tracking-[0.22em] text-[var(--text-tertiary)] transition-colors duration-300 hover:text-[var(--text-primary)] group"
        >
          Return to Leon Galt
          <span className="block w-0 group-hover:w-full h-px bg-[var(--text-primary)] transition-all duration-500 ease-out mt-1.5" />
        </Link>
      </div>
    </div>
  );
}
